export const defaultOptions = {
    "noneOptions": { "dataType": "constantValue", "dataValue": "", "defaultValue": "" },
    "splitOptions": { "dataType": "constantValue", "dataValue": "" },
    "splitValuesOptions": { "dataType": "constantValue", "dataValue": "" },
    "splitWithoutSuffixesOptions": { "dataType": "constantValue", "dataValue": "" },
    "randomIntOptions": { "dataType": "constantValue", "dataValue": "" },
    "currentHourTZOptions": {"timeZoneOffsetValue": "0"},
    "currentMinuteTZOptions": {"timeZoneOffsetValue": "0"},
    "currentDayOfTheWeekTZOptions": {"timeZoneOffsetValue": "0"},
    "lowercaseOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "uppercaseOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "arrayLengthOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "arrayLimitOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "regexOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "replaceOptions": {"dataType": "constantValue", "value": "", "defaultValue": "", "isRegexPattern": false},
    "stringJoinOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "substringOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "itemPositionOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "stringLengthOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "indexOfOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "nElementOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "indexOfArrayOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "nElementArrayOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "userPropertyOptions": {"dataType": "constantValue", "dataValue": ""},
    "lookupOptions": {"dataType": "constantValue", "value": "", "defaultValue": ""},
    "inputCountOptions": {},
    "parseDateOptions": {"dataType": "constantValue", "dataValue": ""},
}